module.exports = __webpack_public_path__ + "static/sheep-b9d4e832a3696d36bab082b66cbdcfde.svg";